import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, TextArea, Form, Input, Message} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';

import settingsApi from '../../store/services/settings';
import Page from '../layout/Page';
import FormContainer from '../form-components/FormContainer';

class EditSettingsScreen extends Component {
  state = {
    loading: true,
    setting: null,
    error: {},
  };

  async componentDidMount() {
    withLifecycles(
      () => settingsApi.fetchById(this.props.match.params.settingId),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            draft.loading = loading;
            draft.error = error;

            if (data && !data.hasErrors) {
              draft.setting = data.result;
            }
          })
        );
      }
    );
  }

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.setting[name] = value;
    });
  };

  _save = () => {
    withLifecycles(
      () => settingsApi.update(this.state.setting),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            draft.loading = loading;
            draft.error = error;
            if (data && !data.hasErrors) {
              this.props.history.push('/manage/settings');
              toastr.success('Setting Updated');
            }
          })
        );
      }
    );
  };

  render() {
    const {loading, setting} = this.state;
    return (
      <Page.Basic title={<Page.HeaderWithActions title="Edit Setting" />}>
        <FormContainer loading={loading}>
          {setting ? this._renderForm() : ''}
        </FormContainer>
      </Page.Basic>
    );
  }

  _renderForm = () => {
    const {error, setting} = this.state;
    return (
      <Form onSubmit={this._save} size="large">
        <Form.Field
          disabled
          name="key"
          placeholder="Name"
          control={Input}
          value={setting.key}
          onChange={this._handleTextChanged}
          label="Name"
        />
        <Form.Field
          name="value"
          placeholder="Value"
          rows="5"
          control={TextArea}
          value={setting.value}
          onChange={this._handleTextChanged}
          label="Value"
        />
        {error.errors && (
          <Message negative>
            {error.errors.map(x => (
              <p key={x.errorMessage}>{x.errorMessage}</p>
            ))}
          </Message>
        )}
        <Button type="Submit" primary>
          Update
        </Button>
        <Button basic as={Link} to="/manage/settings">
          Cancel
        </Button>
      </Form>
    );
  };
}

export default EditSettingsScreen;
